// extracted by mini-css-extract-plugin
export default {"banner":"unclaimed-banner_banner__2vD5z","image":"unclaimed-banner_image__0Rs7J","cta":"unclaimed-banner_cta__byrGF","bold":"unclaimed-banner_bold__GGMhA"};